import React from 'react';
import { alpha, createTheme, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

interface Props {
  // eslint-disable-next-line @typescript-eslint/ban-types
  onSidebarOpen: () => void;
  hideTopBar?: boolean;
}

const Topbar = ({ onSidebarOpen, hideTopBar }: Props): JSX.Element => {
  const theme = useTheme();
  return (
    <Box
      display={'flex'}
      justifyContent={'space-between'}
      alignItems={'center'}
      width={1}
    >
      <Box sx={{ display: hideTopBar?'none': 'flex'  }} alignItems={'center'} marginTop={2}>
        <Button
          onClick={() => onSidebarOpen()}
          aria-label="Filer Listing"
          variant={'outlined'}
          sx={{
            borderRadius: 2,
            minWidth: 'auto',
            padding: 1,
            borderColor: alpha(theme.palette.divider, 0.2),
            marginLeft: 2,
          }}
        >
          Browse Filer List
        </Button>
      </Box>
    </Box>
  );
};

export default Topbar;
